var trackError = require('trackError')
var t = require('i18n').t
var postingSides = require('posting-sides')
var f = require('float')
var moment = require('moment')
var BankFeeAccountWindow = require('../components/bank-fee-account-window')
var NOTIFICATION_KEYS = require('../notificationKeys')
var NOTIFICATION_VARIANT = require('../notificationVariant')
var CustomEvent = require('../constants/customEvent')
var batmask = require('batmask')
var getPeriodData = require('../utils/get-period-data')
var BANK_MATCH_UI_FLOW = require('../constants/bank-match-ui-flow')
var getBankMatchObjectSource = require('../utils/get-bank-match-object-source')
var getBankMatchTrackingHeaders = require('../utils/get-bank-match-tracking-headers')

module.exports = Em.ObjectController.extend({
    needs: ['organization', 'bankSyncMatches', 'bankSyncPossibleSubjects', 'nextVoucherNo'],

    organization: Em.computed.alias('controllers.organization.model'),

    segment: Em.inject.service(),

    matchSuggestions: Em.computed.alias('controllers.bankSyncMatches.matchSuggestions'),

    customEvent: Ember.inject.service(),

    subscriptionLimits: Ember.inject.service(),

    attachmentsUploadsObject: Em.Object.create(),

    attachmentsUploads: function() {
        var matchId = this.get('model.id')
        return this.get('attachmentsUploadsObject')[matchId] || Em.A([])
    }.property('attachmentsUploadsObject'),

    lines: function() {
        return Em.ArrayController.create({
            container: this.container,
            parentController: this,
            model: this.get('model.lines'),
            itemController: 'bank-sync-match-line',
            sortProperties: ['entryDate']
        })
    }.property('model.lines'),

    bankLineId: function() {
        var ids = this.get('model.lines.ids')

        if (ids.length === 0) {
            return this.get('model.id')
        }

        return this.get('model.lines.ids')[0]
    }.property('model.id', 'model.lines'),

    lineCount: function() {
        return this.get('lines.length')
    }.property('lines.length'),

    lineDescription: function() {
        if (!this.get('lines.length')) {
            return ''
        }
        return this.get('model.lines').mapProperty('description').filter(Boolean).join(', ')
    }.property('model.lines.@each.description'),

    lineAmount: function() {
        if (!this.get('lines.length')) {
            return 0
        }
        return this.get('lines').reduce(function(total, line) {
            return total + (line.get('side.isDebit') ? 1 : -1) * line.get('amount')
        }, 0)
    }.property('lines.@each.amount', 'lines.@each.side'),

    subjectAssociations: function() {
        return Em.ArrayController.create({
            container: this.container,
            parentController: this,
            model: this.get('model.subjectAssociations'),
            itemController: 'bank-sync-match-subject-association'
        })
    }.property('model.subjectAssociations'),

    subjectAmount: function() {
        return this.get('subjectAssociations').reduce(function(total, subjectAsscociation) {
            return total + subjectAsscociation.get('sideAmount')
        }, 0)
    }.property('subjectAssociations.@each.sideAmount'),

    isFulfilled: function() {
        if (!this.get('lines.length') || !this.get('subjectAssociations.length')) {
            return false
        }
        return (!Em.isEmpty(this.get('differenceType')) || f.equals(this.get('lineAmount'), this.get('subjectAmount')))
    }.property('lines.length', 'subjectAssociations.length', 'lineAmount', 'subjectAmount', 'differenceType'),

    isMatchSuggestionAcceptDisabled: function() {
        return !!this.get('differenceAmount') && Em.isEmpty(this.get('differenceType'))
    }.property('differenceAmount', 'differenceType'),

    differenceLabel: function() {
        switch (this.get('differenceType')) {
        case 'overpayment':
            return t('bank_sync.overpayment')
        case 'underpayment':
            return t('bank_sync.underpayment')
        case 'bankFee':
            return t('bank_sync.bank_fee')
        }
    }.property('differenceType'),

    differenceAmount: function() {
        // cross currency match is always 1:1
        if (this.get('isCrossCurrencyMatch')) {
            return 0
        }

        if (this.get('hasMatchSuggestion')) {
            var autoMatch = this.get('autoMatch')
            var transaction = autoMatch && autoMatch.transactions && autoMatch.transactions[0]
            var reconcilable = autoMatch && autoMatch.reconcilables && autoMatch.reconcilables[0]
            if (transaction && reconcilable && transaction.currency !== reconcilable.currency) {
                return 0
            }
            var autoMatchViewData = this.get('autoMatchViewData')
            return this.get('lineAmount') - (autoMatchViewData ? autoMatchViewData.rawAmount : 0)
        }

        return this.get('lineAmount') - this.get('subjectAmount')
    }.property('lineAmount', 'subjectAmount', 'hasMatchSuggestion', 'autoMatchViewData', 'autoMatch', 'isCrossCurrencyMatch'),

    formattedDifferenceAmount: function() {
        return Billy.money(this.get('differenceAmount'), this.get('account.currency.id'))
    }.property('differenceAmount'),

    didSelectDifferenceType: function(differenceType) {
        var self = this
        var match = this.get('model')

        function fail(e) {
            match.rollback()
            self.container.lookup('util:notification').warn(NOTIFICATION_KEYS.BANK_SYNC_MATCH_SELECT_DIFFERENT_TYPE, e.message)
        }

        if (differenceType === 'bankFee') {
            BankFeeAccountWindow.getDefaultBankFeeAccount(match.get('account.organization'), this.container)
                .then(function(bankFeeAccount) {
                    match.set('feeAccount', bankFeeAccount)
                        .set('differenceType', differenceType)
                        .save()
                        .then(null, fail)
                })
        } else {
            match.set('differenceType', differenceType)
                .save()
                .then(null, fail)
        }
    },

    linesOrsubjectAssociationsDidChange: function() {
        if (!Em.isEmpty(this.get('differenceType'))) {
            this.set('differenceType', null)
        }
    }.observes('lines.@each', 'subjectAssociations.@each'),

    shouldUseDefaultExpenseAccount: function() {
        return this.get('organization.isFr') && this.get('organization.isCegid')
    }.property('organization'),

    getOldReconUiFlow: function() {
        if (
            this.get('bill.isCreatedFromReconciliation') ||
            this.get('invoice.isCreatedFromReconciliation') ||
            this.get('transaction.isCreatedFromReconciliation')
        ) {
            return BANK_MATCH_UI_FLOW.CREATED
        }

        return BANK_MATCH_UI_FLOW.MATCHED
    },

    getOldReconObjectSource: function(subjects) {
        return getBankMatchObjectSource(subjects)
    },

    reconciliationApiCall: function(bankLines, subjects, differenceType, isAutoMatch, expectedAmount, uiFlow) {
        var self = this
        var api = this.get('api')

        // Use provided expectedAmount if available (for cross-currency suggestions), otherwise calculate from subjectAssociations
        if (expectedAmount === undefined) {
            expectedAmount = this.get('isCrossCurrencyMatch') ? Math.abs(this.get('subjectAmount')) : undefined
        }

        var parameters = {
            differenceType: differenceType,
            expectedAmount: expectedAmount,
            isAutoMatch: !!isAutoMatch
        }
        return api.post('/v2/organizations/' + self.get('organization.id') + '/reconcilable', {
            mask: true,
            headers: getBankMatchTrackingHeaders(uiFlow || BANK_MATCH_UI_FLOW.MATCHED, getBankMatchObjectSource(subjects)),
            payload: {
                reconcilable: {
                    bankLines: bankLines,
                    subjects: subjects,
                    parameters: parameters
                }
            }
        })
    },

    isPayableSubject: function(type) {
        return type === 'bill' || type === 'invoice' || type === 'creditNote' || type === 'externalInvoice'
    },

    doMatch: function() {
        var self = this
        var match = this.get('model')
        var matchesController = self.get('controllers.bankSyncMatches')
        var possibleSubjectsController = self.get('controllers.bankSyncPossibleSubjects')
        var differenceType = this.get('differenceType')

        // Remember the subjects. If one of them is an invoice/bill that was only partially paid, then we must add it back to the possible-subjects list on success
        var subjects = match.get('subjectAssociations').map(function(a) { return a.get('subject') })

        if (!this.verifyExternalInvoiceConditions(subjects, differenceType)) {
            self.container.lookup('util:notification').warn(NOTIFICATION_KEYS.BANK_SYNC_MATCH_SAVE, t('bank_sync.matches.overpayment_external_invoice.error'))
            return
        }

        var transactionsSubjects = subjects.filter(function(subject) {
            return subject && subject._data && !self.isPayableSubject(subject._data.attributes.type)
        })
        var analyticsTypeMap = [
            { condition: this.get('bill.isCreatedFromReconciliation'), type: 'manual_bill_created_and_accepted' },
            { condition: this.get('invoice.isCreatedFromReconciliation'), type: 'manual_invoice_created_and_accepted' },
            { condition: this.get('transaction.isCreatedFromReconciliation'), type: 'manual_transaction_created_and_accepted' }
        ]

        var analyticsType = (analyticsTypeMap.find(function(item) { return item.condition }) || {}).type || 'manual_association_accepted'

        this.get('segment').track('xxx - ml - Bank reconciliation - matching', {
            type: analyticsType
        })

        if (transactionsSubjects.length > 1 && !Em.isEmpty(this.get('differenceType'))) {
            matchesController.addMatch(match)
            match.rollback()
            self.container.lookup('util:notification').warn(NOTIFICATION_KEYS.BANK_SYNC_MATCH_SAVE, t('bank_sync.matches.multiple_journal_postings.error'))
            return
        }

        // if subjects is not bill or invoice, just update the match
        if (transactionsSubjects.length > 0) {
            matchesController.removeMatch(match)
            match.set('isApproved', true)

            return match.save({ headers: getBankMatchTrackingHeaders(this.getOldReconUiFlow(), this.getOldReconObjectSource(subjects)) })
                .then(function(result) {
                    if (result) {
                        self.trackMatchResult(result)
                    }

                    matchesController.loadMatchSuggestions()
                    // Add any still unpaid invoices/bills back to the possible-subjects list
                    subjects.forEach(function(subject) {
                        if ((subject instanceof Billy.Invoice || subject instanceof Billy.ExternalInvoice || subject instanceof Billy.Bill) && !subject.get('isPaid')) {
                            possibleSubjectsController.addSubject(subject)
                        }
                    })
                }, function(e) {
                    matchesController.addMatch(match)
                    match.rollback()
                    self.container.lookup('util:notification').warn(NOTIFICATION_KEYS.BANK_SYNC_MATCH_SAVE, e.message)
                })
        }
        // if subjects is bill or invoice, then reconcile the bank line
        var subjectsMap = subjects.map(function(subject) {
            return self.convertToXfModel(self.getSubjectType(subject._data.attributes.type, subject._data.attributes.invoiceNo), subject.get('id'))
        })
        var bankLines = this.get('lines').mapBy('id')
        self.reconciliationApiCall(bankLines, subjectsMap, differenceType, false, undefined, this.getOldReconUiFlow())
            .then(function(result) {
                matchesController.removeMatch(match)

                // Add any still unpaid invoices/bills back to the possible-subjects list
                subjects.forEach(function(subject) {
                    if (subject instanceof Billy.Invoice || subject instanceof Billy.ExternalInvoice || subject instanceof Billy.Bill) {
                        var resSubjects
                        if (subject instanceof Billy.Invoice || subject instanceof Billy.ExternalInvoice) {
                            resSubjects = result.invoices
                        } else {
                            resSubjects = result.bills
                        }
                        var resSubject = resSubjects.find(function(s) { return s.id === subject.get('id') })
                        subject.set('isPaid', resSubject.isPaid || false)
                        if (resSubject.balance) {
                            subject.set('balance', resSubject.balance)
                        }
                        if (!subject.get('isPaid')) {
                            possibleSubjectsController.addSubject(subject)
                        }
                    }
                })
            }, function(e) {
                matchesController.addMatch(match)
                self.container.lookup('util:notification').warn(NOTIFICATION_KEYS.BANK_SYNC_MATCH_SAVE, e.message || t('something_went_wrong'))
            })
    },

    verifyExternalInvoiceConditions: function(subjects, differenceType) {
        var cashAccountingBasisExists = subjects.some(function(subject) {
            return subject instanceof Billy.ExternalInvoice && subject.get('accountingBasis') === 'cash'
        })

        if (cashAccountingBasisExists && differenceType) {
            return false
        }

        return true
    },

    getSubjectType: function(subjectType, invoiceNo) {
        if (subjectType === 'creditNote') {
            if (invoiceNo) {
                return 'invoice'
            }
            return 'bill'
        }

        if (subjectType === 'invoice' && !invoiceNo) {
            return 'externalInvoice'
        }

        return subjectType
    },

    matchBankLine: function(matchId, isAutoMatch) {
        var api = this.get('api')
        var matchEndpoint = '/v2/bankLineMatches/' + matchId

        return api.request('PUT', matchEndpoint, {
            accept: 'application/json',
            headers: getBankMatchTrackingHeaders(BANK_MATCH_UI_FLOW.MATCHED, getBankMatchObjectSource(['posting'])),
            payload: {
                bankLineMatch: {
                    id: matchId,
                    isApproved: true,
                    differenceType: null,
                    isAutoMatch: !!isAutoMatch
                }
            }
        })
    },

    convertToXfModel: function(subjectType, subjectId) {
        var subjectTypes = {
            bill: 'Xf\\Model\\AbstractBill',
            externalInvoice: 'Xf\\Model\\ExternalInvoice',
            invoice: 'Xf\\Model\\AbstractInvoice',
            salesTaxReturn: 'Xf\\Model\\SalesTaxReturn',
            daybookTransaction: 'Xf\\Model\\DaybookTransaction',
            posting: 'Xf\\Model\\Posting'
        }
        var modelPrefix = subjectTypes[subjectType] || subjectTypes.posting
        return '' + modelPrefix + ':' + subjectId
    },

    addSubjectAssociation: function(matchId, subjectReferenceId) {
        var api = this.get('api')
        var subjectAssociationsEndpoint = '/v2/bankLineSubjectAssociations'

        return api.request('POST', subjectAssociationsEndpoint, {
            accept: 'application/json',
            payload: {
                bankLineSubjectAssociation: {
                    matchId: matchId,
                    subjectReference: subjectReferenceId
                }
            }
        })
    },

    reconcileBankLine: function(subjects, isAutoMatch, expectedAmount) {
        var bankLines = this.get('lines').mapBy('id')
        return this.reconciliationApiCall(bankLines, subjects, this.get('differenceType'), isAutoMatch, expectedAmount, BANK_MATCH_UI_FLOW.MATCHED)
    },

    trackMatchResult: function(result) {
        var segment = this.container.lookup('service:segment')

        if (!result || !result.salesTaxReturns || !result.salesTaxReturns.length) {
            return
        }

        for (var i = 0; i < result.salesTaxReturns.length; i++) {
            var salesTaxReturn = result.salesTaxReturns[i]
            var periodData = getPeriodData(salesTaxReturn.period)
            segment.track('VAT Declaration Payment Created (Client)', {
                period_settled: periodData.period_settled,
                year: periodData.year,
                context: 'reconciliation',
                type: salesTaxReturn.correctionNo > 0 ? 'correction' : 'normal'
            })
        }
    },

    doAutoMatch: function() {
        var self = this
        var transaction = this.get('autoMatch.transactions')[0]
        var subjectReference = this.get('autoMatch.reconcilables')[0]
        var matchesController = self.get('controllers.bankSyncMatches')
        var possibleSubjectsController = self.get('controllers.bankSyncPossibleSubjects')
        var matchesElement = document.querySelector('.matches')
        var currentScrollTop = matchesElement ? matchesElement.scrollTop : 0
        var matchId = this.get('model.id')

        var isCrossCurrency = transaction.currency !== subjectReference.currency
        var isAmountEqual = !isCrossCurrency && (Math.abs(transaction.amount) - Math.abs(subjectReference.amount) === 0)
        var expectedAmount = isCrossCurrency ? Math.abs(subjectReference.amount) : undefined

        this.set('hasMatchSuggestion', false)
        var subjectIdMap = self.convertToXfModel(self.getSubjectType(subjectReference.type, subjectReference.invoice_number), subjectReference.id.split(':')[1])
        var isPayable = self.isPayableSubject(subjectReference.type)

        var handleResult = function(result) {
            var match = self.get('model')
            var promise

            if (result) {
                self.trackMatchResult(result)
            }

            if (isAmountEqual || isCrossCurrency) {
                matchesController.removeMatch(match)
                promise = Em.RSVP.resolve()
            } else {
                // reload matches to be able to do next action on the match
                batmask.mask()
                BD.store.unloadAllByType(Billy.BankLineMatch)
                promise = matchesController.load()
            }

            return promise
        }
        var finalize = function() {
            return matchesController.loadMatchSuggestions()
                .then(function() { return possibleSubjectsController.load() })
                .then(function() {
                    batmask.unmask()
                    matchesElement.scrollTop = currentScrollTop
                })
        }
        var handleError = function(error) {
            batmask.unmask()
            self.set('hasMatchSuggestion', true)
            self.container.lookup('util:notification').warn(NOTIFICATION_KEYS.BANK_SYNC_MATCH_SAVE, error.message || t('something_went_wrong'))
        }

        if (isPayable) {
            /** Auto match ( by matching service) always happens for between 1 single bankLine and Subject, so for this function it will be always one single subject */
            this.reconcileBankLine([subjectIdMap], true, expectedAmount)
                .then(handleResult)
                .then(finalize)
                .catch(handleError)
            this.get('segment').track('xxx - ml - Bank reconciliation - matching', { type: 'automatic_suggestion_accepted' })
            this.get('segment').track('XXX - Reconciliation - Reconciliation Suggestion Accepted (Client)')
        } else {
            this.addSubjectAssociation(matchId, subjectReference.id)
                .then(function() {
                    return (isAmountEqual || isCrossCurrency) ? self.matchBankLine(matchId, true) : Em.RSVP.resolve()
                })
                .then(handleResult)
                .then(finalize)
                .catch(handleError)
            this.get('segment').track('xxx - ml - Bank reconciliation - matching', { type: 'automatic_suggestion_accepted' })
            this.get('segment').track('XXX - Reconciliation - Reconciliation Suggestion Accepted (Client)')
        }
    },

    autoMatch: function() {
        var matchSuggestions = this.get('matchSuggestions')
        var bankLineId = this.get('bankLineId')

        if (!matchSuggestions || matchSuggestions.length === 0) {
            return null
        }

        return matchSuggestions.filter(function(suggestion) {
            return suggestion.transactions.find(function(transaction) {
                return transaction.id === bankLineId
            })
        }).sort(function(a, b) {
            return a.confidence > b.confidence
        })[0]
    }.property('matchSuggestions'),

    autoMatchViewData: null,

    inlineCreator: null,

    hasInvoiceEditor: Em.computed.equal('inlineCreator', 'invoice'),

    hasBillEditor: Em.computed.equal('inlineCreator', 'bill'),

    hasTransactionEditor: Em.computed.equal('inlineCreator', 'transaction'),

    isCrossCurrencyMatch: function() {
        var accountCurrencyId = this.get('account.currency.id')
        var subjectCurrencies = this.get('subjectAssociations').mapBy('subject.currency.id')
        return subjectCurrencies.some(function(currencyId) {
            return currencyId !== accountCurrencyId
        })
    }.property('account.currency.id', 'subjectAssociations.@each.subject.currency.id'),

    hasMatchSuggestion: false,

    isDroppable: function() {
        return !this.get('hasMatchSuggestion')
    }.property('hasMatchSuggestion'),

    rejectMatchSuggestion: function() {
        var self = this
        var api = this.get('api')
        var endpointUrl = '/api/matching-service/' + this.get('organization.id') + '/matches/reject'

        api.request('POST', endpointUrl, {
            accept: 'application/json',
            headers: getBankMatchTrackingHeaders(),
            payload: this.get('autoMatch')
        }).catch(function() {
            self.set('hasMatchSuggestion', true)
            self.container.lookup('util:notification').warn(NOTIFICATION_KEYS.BANK_SYNC_MATCH_SAVE, t('something_went_wrong'))
        })

        this.get('segment').track('xxx - ml - Bank reconciliation - matching', {
            type: 'automatic_suggestion_rejected'
        })
        this.get('segment').track('XXX - Reconciliation - Reconciliation Suggestion Rejected (Client)')
    },

    getDescriptionFromReconcilable: function(reconcilable) {
        switch (reconcilable.type) {
        case 'bill':
            return t('invoice.description.approved_bill', { billNo: reconcilable.invoice_number, name: reconcilable.contact.name })
        case 'invoice':
        case 'externalInvoice':
            return t('invoice.description.approved_invoice', { invoiceNo: reconcilable.invoice_number, name: reconcilable.contact.name })
        case 'posting':
            var postingId = reconcilable.id.split(':').pop()
            var posting = BD.store.recordForTypeAndId(Billy.Posting, postingId)
            return (posting && posting.get('transaction.originatorName')) || reconcilable.description
        default:
            return reconcilable.description
        }
    },

    observeMatchSuggestions: function() {
        var self = this
        var autoMatch = this.get('autoMatch')
        var subjectAssociationsIds = this.get('model.subjectAssociations.ids')
        var hasSubjectAssociations = subjectAssociationsIds && subjectAssociationsIds.length !== 0
        var hasMatchSuggestion = !!autoMatch && !hasSubjectAssociations

        if (hasMatchSuggestion) {
            var reconcilable = this.get('autoMatch.reconcilables')[0]
            var amountValue = reconcilable.amount
            var numberAmount = Math.abs(amountValue)
            var amountSign = amountValue < 0 ? '-' : '+'
            var amount = {
                value: amountSign + Billy.money(numberAmount),
                color: amountValue <= 0 ? 'red-text' : 'green-text'
            }
            var date = reconcilable.entry_date

            this.set('autoMatchViewData', {
                amount: amount,
                rawAmount: amountValue,
                date: date,
                description: self.getDescriptionFromReconcilable(reconcilable)
            })
        }

        this.set('hasMatchSuggestion', hasMatchSuggestion)
    }.observes('matchSuggestions', 'model.subjectAssociations'),

    inlineCreateOptions: function() {
        var options = []
        var lineAmount = this.get('lineAmount')
        if (lineAmount > 0) {
            options.push(Ember.Object.create({
                value: 'invoice',
                name: t('bank_sync.create_invoice')
            }))
        } else if (lineAmount < 0) {
            options.push(Ember.Object.create({
                value: 'bill',
                name: t('bank_sync.create_bill')
            }))
        }
        options.push(Ember.Object.create({
            value: 'transaction',
            name: t('bank_sync.create_transaction')
        }))
        return options
    }.property('lineAmount'),

    invoice: null,

    invoiceIsUploading: false,

    enableInvoiceCreator: function() {
        var entryDate = this.get('model.entryDate') || moment()
        var invoice = Billy.Invoice.createRecord({
            organization: this.get('organization'),
            currency: this.get('account.currency'),
            taxMode: 'incl',
            entryDate: entryDate
        })
        Billy.InvoiceLine.createRecord({
            invoice: invoice
        })
        this.set('invoice', invoice)
    },

    bill: null,

    billIsUploading: false,

    billAccountNatures: function() {
        return [Billy.AccountNature.find('expense'), Billy.AccountNature.find('asset')]
    }.property(),

    taxRatePlaceholder: function() {
        return this.get('organization.hasVat') ? t('bank_sync.select_vat_rate') : t('bank_sync.select_tax_rate')
    }.property('organization.hasVat'),

    getPredictedContraAccount: function() {
        var contraAccounts = this.get('model.lines')
            .map(function(line) { return line.get('contraAccount') })
            .filter(function(contraAccount) { return !!contraAccount })
        return contraAccounts[0]
    },

    getDefaultAccount: function() {
        // Hardcoded predefined account ID for cegid
        var predefinedAccountId = 'NGZiOWY4MTRkNzZkNGFlYj'

        var accounts = Billy.Account.all()
        var account = accounts.find(function(account) {
            return account.get('predefinedAccount.id') === predefinedAccountId
        })
        return account
    },

    enableBillCreator: function() {
        var organization = this.get('organization')
        var entryDate = this.get('model.entryDate') || moment()
        var bill = Billy.Bill.createRecord({
            organization: organization,
            currency: this.get('account.currency'),
            taxMode: 'incl',
            voucherNo: organization.get('hasBillVoucherNo') ? this.get('controllers.nextVoucherNo').getAndIncrement() : null,
            entryDate: entryDate
        })
        Billy.BillLine.createRecord({
            bill: bill,
            description: this.get('lineDescription'),
            account: this.get('shouldUseDefaultExpenseAccount') ? this.getDefaultAccount() : this.getPredictedContraAccount()
        })
        this.set('bill', bill)
    },

    transaction: null,

    transactionIsUploading: false,

    enableTransactionCreator: function() {
        var organization = this.get('organization')
        var defaultDaybook = organization.get('defaultDaybook')

        if (this.get('account.currency.id') !== organization.get('baseCurrency.id')) {
            this.set('inlineCreator', null)
            this.container.lookup('util:notification').warn(NOTIFICATION_KEYS.BANK_SYNC_TRANSACTION_CREATE, t('bank_sync.transaction_not_allowed_with_foreign_currencies'))
            return
        }
        var transaction = Billy.DaybookTransaction.createRecord({
            organization: organization,
            daybook: defaultDaybook,
            voucherNo: this.get('controllers.nextVoucherNo').getAndIncrement()
        })

        Billy.DaybookTransactionLine.createRecord({
            daybookTransaction: transaction,
            text: this.get('lineDescription'),
            account: this.getPredictedContraAccount()
        })
        this.set('transaction', transaction)
    },

    getAllAttachmentsUploadsIds: function() {
        var attachmentsUploadsIds = []
        var attachmentsUploadsObject = this.get('attachmentsUploadsObject')
        var matchIds = Object.keys(attachmentsUploadsObject)

        matchIds.forEach(function(matchId) {
            var attachments = attachmentsUploadsObject[matchId]

            attachments.forEach(function(attachment) {
                attachmentsUploadsIds.push(attachment.id)
            })
        })

        return attachmentsUploadsIds
    },

    updateAttachmentOwnerReference: function(ownerId, ownerType, attachmentId) {
        return this.get('api').putData('/v2/attachments/' + attachmentId, {
            attachment: {
                ownerReference: ownerType + ':' + ownerId,
                ownerId: ownerId
            }
        }).catch(function(error) {
            trackError(error)
        })
    },

    updateAttachments: function(ownerType, attachments) {
        var self = this
        var ownerId

        switch (ownerType) {
        case 'bill':
            ownerId = self.get('bill.id')
            break
        case 'daybookTransaction':
            ownerId = self.get('transaction.id')
            break
        case 'invoice':
            ownerId = self.get('invoice.id')
            break
        }

        return Em.RSVP.Promise.all(attachments.map(function(attachment) {
            var attachmentId = attachment.id
            return self.updateAttachmentOwnerReference(ownerId, ownerType, attachmentId)
        }))
    },

    createSubjectAssociationAndMatch: function(subject) {
        var self = this
        var association = Billy.BankLineSubjectAssociation.createRecord({
            match: this.get('model'),
            subject: subject
        })

        return association.save()
            .then(function() {
                self.set('inlineCreator', null)
                return self.doMatch()
            }, function(e) {
                association.rollback()
                self.container.lookup('util:notification').warn(NOTIFICATION_KEYS.BANK_SYNC_V2_SUBJECT_ASSOCIATION_CREATE, e.message)
            })
    },

    actions: {
        doMatch: function() {
            this.doMatch()
        },

        doAutoMatch: function() {
            this.doAutoMatch()
        },

        doUnapproveMatch: function() {
            this.doUnapproveMatch()
        },

        rejectSuggestion: function() {
            this.set('hasMatchSuggestion', false)
            this.rejectMatchSuggestion()
        },

        createInline: function(inlineCreator) {
            var self = this
            switch (inlineCreator) {
            case 'invoice':
                self.get('segment').track('xxx - reconciliation - invoice creation click')
                var isShineInvoicingAccountingSetup = self.get('organization.isShineInvoicingAccountingSetup')
                if (isShineInvoicingAccountingSetup) {
                    self.get('controllers.organization').transitionToRoute('invoices.new')
                } else {
                    self.get('subscriptionLimits').checkForInvoiceLimitAndExecute(function() {
                        self.set('inlineCreator', inlineCreator)
                        self.enableInvoiceCreator()
                    })
                }
                break
            case 'bill':
                self.get('subscriptionLimits').checkForExpenseLimitAndExecute(function() {
                    self.set('inlineCreator', inlineCreator)
                    self.enableBillCreator()
                })
                self.get('segment').track('xxx - expenses - create purchase click', {
                    source: 'Reconciliation'
                })
                break
            case 'transaction':
                self.get('subscriptionLimits').checkForExpenseLimitAndExecute(function() {
                    self.set('inlineCreator', inlineCreator)
                    self.enableTransactionCreator()
                })
                break
            }
        },

        disableInvoiceCreator: function() {
            var invoice = this.get('invoice')
            var attachmentsList = this.get('attachmentsUploads')
            this.get('attachmentsUploads').removeObjects(attachmentsList)
            invoice.rollback()
            this.set('invoice', null)
            this.set('inlineCreator', null)
        },

        saveInvoice: function() {
            if (this.get('invoiceIsUploading')) {
                this.container.lookup('util:notification').notify(NOTIFICATION_KEYS.STILL_UPLOADING, t('still_uploading'), NOTIFICATION_VARIANT.INFO)
                return
            }

            var self = this
            var invoice = this.get('invoice')
            var line = invoice.get('lines.firstObject')
            var attachments = this.get('attachmentsUploads')
            var customEvent = self.get('customEvent')
            this.set('invoice.isCreatedFromReconciliation', invoice.get('isNew'))

            if (!invoice.get('entryDate')) {
                invoice.setProperties({
                    entryDate: this.get('entryDate')
                })
            }

            line.setProperties({
                quantity: 1,
                unitPrice: this.get('lineAmount')
            })
            customEvent.dispatchEvent(CustomEvent.InvoiceUpdated)
            invoice.save({
                properties: {
                    state: 'approved'
                },
                embed: ['lines', 'attachments']
            })
                .then(this.createSubjectAssociationAndMatch.bind(this, invoice))
                .then(this.updateAttachments.bind(this, 'invoice', attachments))
                .catch(function(e) {
                    self.container.lookup('util:notification').notify(NOTIFICATION_KEYS.INVOICE_SAVE, e.message, NOTIFICATION_VARIANT.ERROR)
                })
                .then(function() {
                    if (customEvent) {
                        customEvent.dispatchEvent(CustomEvent.InvoiceCreated)
                        customEvent.dispatchEvent(CustomEvent.UploadsUpdated)
                    }
                })
        },

        didSelectBillContact: function(contact) {
            this.get('bill.lines').forEach(function(line) {
                line.populateContactDefaults()
            })
        },

        didSelectBillAccount: function(account) {
            if (account) {
                this.set('bill.lines.firstObject.taxRate', account.get('taxRate'))
            }
        },

        disableBillCreator: function() {
            var bill = this.get('bill')
            var attachmentsList = this.get('attachmentsUploads')
            this.get('attachmentsUploads').removeObjects(attachmentsList)
            this.get('controllers.nextVoucherNo').release(bill.get('voucherNo'))
            bill.rollback()
            this.set('bill', null)
            this.set('inlineCreator', null)
        },

        saveBill: function() {
            if (this.get('billIsUploading')) {
                this.container.lookup('util:notification').notify(NOTIFICATION_KEYS.STILL_UPLOADING, t('still_uploading'), NOTIFICATION_VARIANT.INFO)
                return
            }

            var self = this
            var bill = this.get('bill')
            var line = bill.get('lines.firstObject')
            var amount = -1 * this.get('lineAmount')
            var attachments = this.get('attachmentsUploads')
            var customEvent = self.get('customEvent')
            this.set('bill.isCreatedFromReconciliation', bill.get('isNew'))

            if (!bill.get('entryDate')) {
                bill.setProperties({
                    entryDate: this.get('entryDate')
                })
            }

            line.setProperties({
                amount: amount
            })
            customEvent.dispatchEvent(CustomEvent.BillUpdated)
            bill.save({
                properties: {
                    state: 'approved'
                },
                embed: ['lines', 'attachments']
            })
                .then(this.createSubjectAssociationAndMatch.bind(this, bill))
                .then(this.updateAttachments.bind(this, 'bill', attachments))
                .catch(function(e) {
                    self.container.lookup('util:notification').notify(NOTIFICATION_KEYS.BILL_SAVE, e.message, NOTIFICATION_VARIANT.ERROR)
                })
                .then(function() {
                    if (customEvent) {
                        customEvent.dispatchEvent(CustomEvent.BillCreated)
                        customEvent.dispatchEvent(CustomEvent.UploadsUpdated)
                    }
                })
        },

        didSelectTransactionAccount: function(account) {
            this.set('transaction.lines.firstObject.taxRate', account && account.get('taxRate'))
        },

        disableTransactionCreator: function() {
            var transaction = this.get('transaction')
            var attachmentsList = this.get('attachmentsUploads')
            this.get('attachmentsUploads').removeObjects(attachmentsList)
            this.get('controllers.nextVoucherNo').release(transaction.get('voucherNo'))
            transaction.rollback()
            this.set('transaction', null)
            this.set('inlineCreator', null)
        },

        saveTransaction: function() {
            if (this.get('transactionIsUploading')) {
                this.container.lookup('util:notification').notify(NOTIFICATION_KEYS.STILL_UPLOADING, t('still_uploading'), NOTIFICATION_VARIANT.INFO)
                return
            }

            var self = this
            var match = this.get('model')
            var account = match.get('account')
            var lineAmount = this.get('lineAmount')
            var daybookTransaction = this.get('transaction')
            var line = daybookTransaction.get('lines.firstObject')
            var attachments = this.get('attachmentsUploads')
            var customEvent = this.get('customEvent')
            this.set('transaction.isCreatedFromReconciliation', daybookTransaction.get('isNew'))

            // Update daybook transaction and line with properties
            daybookTransaction.setProperties({
                entryDate: this.get('entryDate')
            })
            line.setProperties({
                contraAccount: account,
                amount: Math.abs(lineAmount),
                side: lineAmount < 0 ? postingSides.debit : postingSides.credit
            })
            customEvent.dispatchEvent(CustomEvent.TransactionUpdated)
            // Save the daybook transaction
            daybookTransaction.save({
                properties: {
                    state: 'approved'
                },
                embed: ['lines', 'attachments']
            }).promise
                // Find transactions for the daybook transaction
                .then(function() {
                    return Billy.Transaction.find({
                        organizationId: self.get('organization.id'),
                        originatorReference: daybookTransaction.get('reference')
                    }).promise
                })

                // Find postings for a single transaction
                .then(function(transactions) {
                    if (transactions.get('length') !== 1) {
                        throw new Error('Newly created DaybookTransaction should be the originator of exactly 1 Transaction. ' + transactions.get('length') + ' found')
                    }
                    return transactions.objectAt(0).get('postings').promise
                })

                // Associate and match
                .then(function(postings) {
                    postings = postings.filterBy('account', account)
                    if (postings.get('length') !== 1) {
                        throw new Error('Newly created Transaction for DaybookTransaction should have exactly 1 Posting on the bank account. ' + postings.get('length') + ' found')
                    }
                    return self.createSubjectAssociationAndMatch(postings.objectAt(0))
                })
                .then(this.updateAttachments.bind(this, 'daybookTransaction', attachments))
                .catch(function(e) {
                    self.container.lookup('util:notification').notify(NOTIFICATION_KEYS.BANK_SYNC_TRANSACTION_CREATE, e.message, NOTIFICATION_VARIANT.ERROR)
                })
                .then(function() {
                    if (customEvent) {
                        customEvent.dispatchEvent(CustomEvent.TransactionCreated)
                        customEvent.dispatchEvent(CustomEvent.UploadsUpdated)
                    }
                })
        },

        showReceipts: function() {
            var self = this
            var selector = this.container.lookup('component:choose-receipt-modal')
            selector.set('idsToSkipStringified', JSON.stringify(this.getAllAttachmentsUploadsIds()))
            selector.show()

            selector.on('didSelect', function(attachment) {
                self.addAttachment(attachment)
            })
        },

        handleDeleteUploadsAttachment: function(attachmentId) {
            var attachment = this.get('attachmentsUploads').find(function(attachment) {
                return attachment.get('id') === attachmentId
            })

            this.get('attachmentsUploads').removeObject(attachment)
        }
    },

    addAttachment: function(attachment) {
        // Find the attachment and keep the ember instance of it
        var attachmentInstance = Billy.Attachment.find(attachment.id)

        // Check if the instance contain a file; get it of doesn't
        if (!attachmentInstance.get('file')) {
            var fileId = attachment.file.id
            var file = Billy.File.find(fileId)
            attachmentInstance.set('file', file)
        }

        // Get attachmentsUploads for the match
        var matchId = this.get('model.id')
        var attachmentsUploads = this.get('attachmentsUploadsObject')[matchId]

        // Initialize array if it does't exist
        if (!attachmentsUploads) {
            this.get('attachmentsUploadsObject').set(matchId, Em.A([]))
        }

        // Update the array with the attachment instance
        var attachmentsUploadsUpdated = this.get('attachmentsUploadsObject')[matchId]
        attachmentsUploadsUpdated.pushObject(attachmentInstance)
        this.get('attachmentsUploadsObject').set(matchId, attachmentsUploadsUpdated)
        this.notifyPropertyChange('attachmentsUploadsObject')
    },

    didDropLine: function(line) {
        var self = this
        var match = this.get('model')
        var otherMatch = line.get('match')
        var matchesController = this.get('controllers.bankSyncMatches')
        var possibleSubjectsController = this.get('controllers.bankSyncPossibleSubjects')
        var isOnly = otherMatch.get('lines.length') === 1
        var otherMatchSubjects
        var otherMatchIndex

        // Remove otherMatch from matches controller, and add any subjects to possible subjects, if the line is the only one
        if (isOnly) {
            // Remember the original index so we can restore the match
            // at the same position if the save fails
            var matchesArray = matchesController.get('model.model')
            otherMatchIndex = matchesArray.indexOf(otherMatch)

            matchesController.removeMatch(otherMatch, true)
            otherMatchSubjects = otherMatch.get('subjectAssociations').mapBy('subject')
            otherMatchSubjects.forEach(possibleSubjectsController.addSubject.bind(possibleSubjectsController))
        }

        // Add the line to the this match and save
        line.set('match', match)
        line.save()
            .then(function() {
                // If the request succeeded, we delete the otherMatch if the line was the only one
                if (!otherMatch.get('isDestroying') && isOnly) {
                    otherMatch.deleteRecord()
                }
                matchesController.loadMatchSuggestions()
            }, function(e) {
                self.container.lookup('util:notification').warn(NOTIFICATION_KEYS.BANK_SYNC_LINE_DROP, e.message)
                // If the request failed, we add the otherMatch back and remove the possible subjects again
                line.rollback()

                if (!otherMatch.get('isDestroying') && isOnly) {
                    var matchesArrayOnError = matchesController.get('model.model')

                    if (typeof otherMatchIndex === 'number' && otherMatchIndex >= 0 && otherMatchIndex <= matchesArrayOnError.get('length')) {
                        matchesArrayOnError.insertAt(otherMatchIndex, otherMatch)
                    } else {
                        // Fallback if we for some reason don't have a valid index
                        matchesController.addMatch(otherMatch)
                    }

                    otherMatchSubjects.forEach(possibleSubjectsController.removeSubject.bind(possibleSubjectsController))
                }
            })
    },

    didDropSubjectAssociation: function(association) {
        var self = this
        var match = this.get('model')
        association.set('match', match)
        association.save()
            .then(null, function(e) {
                self.container.lookup('util:notification').warn(NOTIFICATION_KEYS.BANK_SYNC_V2_SUBJECT_ASSOCIATION_DROP, e.message)
                association.rollback()
            })
    },

    didDropSubject: function(subject) {
        var self = this
        var match = this.get('model')

        // All subjects should be in the same currency, otherwise fail the drop
        if (!self.matchUniqueCurrency(match, subject)) {
            return
        }

        var possibleSubjectsController = this.get('controllers.bankSyncPossibleSubjects')

        possibleSubjectsController.removeSubject(subject)

        var association = Billy.BankLineSubjectAssociation.createRecord({
            match: match,
            subject: subject
        })
        association.save()
            .then(null, function(e) {
                self.container.lookup('util:notification').warn(NOTIFICATION_KEYS.BANK_SYNC_V2_SUBJECT_ASSOCIATION_DROP, e.message)
                association.rollback()
                possibleSubjectsController.addSubject(subject)
            })

        this.get('segment').track('xxx - ml - Bank reconciliation - matching', {
            type: 'manual_association_created'
        })
    },

    matchUniqueCurrency: function(match, subject) {
        return match.get('subjectAssociations').every(function(association) {
            return association.get('subject.currency.id') === subject.get('currency.id')
        })
    },

    doUnapproveMatch: function() {
        var bankSyncMatchesController = this.get('controllers.bankSyncMatches')
        var match = this.get('model')
        bankSyncMatchesController.unapproveMatch(match)
    }
})
